/* tslint:disable:no-submodule-imports */
import React, { forwardRef, useCallback, useState } from 'react';
import { useDispatch } from '@/state/store';
import { ActionType } from '@/actions/actiontypes';
import { MeasurementType } from '@/state/MeasurementState';
import { MapControlMenu } from './MapControlMenu';

const Measure = forwardRef<HTMLButtonElement>((_, ref) => {
    const dispatch = useDispatch();
    const [selected, setSelected] = useState<MeasurementType>();

    const onClick = useCallback(
        (measurementType: MeasurementType | undefined, active: boolean) => {
            dispatch({
                type: ActionType.MEASURE_TOGGLE_ACTIVE,
                measurementType: measurementType,
                active: active,
            });
        },
        [dispatch]
    );

    const handleMeasurementTypeOnClick = (
        measurementType: MeasurementType | undefined
    ) => {
        const newSelected = selected !== measurementType ? measurementType : undefined;
        setSelected(newSelected);
        const isSelected = newSelected !== undefined && newSelected === measurementType;
        onClick(measurementType, isSelected);
    };

    return (
        <MapControlMenu
            ref={ref}
            id="map-measurement-options"
            label="Måling"
            title="Start måling"
            expandedTitle={selected === undefined ? 'Lukk måling' : 'Avslutt måling'}
            icon={<i className="o-icon-ruler c-map-control-menu__toggle-icon" />}
            onToggle={expanded =>
                handleMeasurementTypeOnClick(
                    expanded ? MeasurementType.LINESTRING : undefined
                )
            }
        >
            <button
                type="button"
                title={
                    selected === 'LineString'
                        ? 'Avslutt måling'
                        : 'Start måling av avstand'
                }
                className="c-map-control-menu__option o-btn-square"
                aria-pressed={selected === 'LineString'}
                onClick={() => handleMeasurementTypeOnClick(MeasurementType.LINESTRING)}
            >
                <i
                    className={`o-icon-ruler-straight${
                        selected === 'LineString' ? '--active' : ''
                    } c-map-control-menu__option-icon`}
                />
                <span
                    className={`o-btn-square__title
                        ${selected === 'LineString' ? 'c-map-control-menu__active-text' : ''}`}
                >
                    Avstand
                </span>
            </button>
            <button
                type="button"
                title={
                    selected === 'Polygon' ? 'Avslutt måling' : 'Start måling av areal'
                }
                className="c-map-control-menu__option o-btn-square"
                aria-pressed={selected === 'Polygon'}
                onClick={() => handleMeasurementTypeOnClick(MeasurementType.POLYGON)}
            >
                <i
                    className={`o-icon-ruler-sqm${
                        selected === 'Polygon' ? '--active' : ''
                    } c-map-control-menu__option-icon`}
                />
                <span
                    className={`o-btn-square__title
                        ${selected === 'Polygon' ? 'c-map-control-menu__active-text' : ''}`}
                >
                    Areal
                </span>
            </button>
        </MapControlMenu>
    );
});
Measure.displayName = 'Measure';
export { Measure };
